import { render, staticRenderFns } from "./TheDocuments.vue?vue&type=template&id=29e01071"
import script from "./TheDocuments.vue?vue&type=script&lang=ts"
export * from "./TheDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports